var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBxMenu(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 28 25",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "a35727e7-a796-48fc-9b7f-2edd4a06393d",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", {
    id: "b4dff68e-5dd6-43a6-9eba-801d745e3422",
    "data-name": "Group 457"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.5,4.5H2.5a2,2,0,0,1,0-4h23a2,2,0,0,1,0,4Z",
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5,24.5H2.5a2,2,0,0,1,0-4h23a2,2,0,0,1,0,4Z",
    style: {
      fill: "#707070"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5,14.5H2.5a2,2,0,0,1,0-4h23a2,2,0,0,1,0,4Z",
    style: {
      fill: "#707070"
    }
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBxMenu);
export default __webpack_public_path__ + "static/media/bxMenu.85bc03cffccf9722a9f847d7e94f7cfd.svg";
export { ForwardRef as ReactComponent };